import { render, staticRenderFns } from "./DisableDbClickButton.vue?vue&type=template&id=6067eb78&"
import script from "./DisableDbClickButton.vue?vue&type=script&lang=ts&"
export * from "./DisableDbClickButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports